module.exports = "dist/954bbdeb86483e4ffea00c4591530ece.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Thin.woff2
// module id = 204
// module chunks = 0